const rows = [
  {
    dimension: 'Who fills the schedule',
    legacy: 'The VPE, by hand, every week',
    speechAgenda: 'Members claim, auto-assign finishes it',
  },
  {
    dimension: 'Where the agenda lives',
    legacy: 'A file one person edits and re-sends',
    speechAgenda: 'One live link, current for everyone, no login to view',
  },
  {
    dimension: 'How guests find you',
    legacy: 'They don’t - the schedule is internal',
    speechAgenda: 'A public page, guests join in 3 clicks',
  },
  {
    dimension: 'Where it works',
    legacy: 'Desktop tables',
    speechAgenda: 'Any phone, every screen',
  },
  {
    dimension: 'Who can see member data',
    legacy: 'All-or-nothing',
    speechAgenda: 'Role-based access control',
  },
]

export default function LandingWhy() {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-indigo-600">
            Why Speech Agenda
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Not a faster spreadsheet - a schedule your whole club runs
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Great clubs run on FreeToastHost, Easy-Speak, and spreadsheets
            every day. Those tools help one overworked officer fill the
            schedule faster. Speech Agenda changes who does the work
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
          <div className="hidden grid-cols-3 gap-x-6 px-6 pb-4 sm:grid">
            <p className="text-sm font-semibold text-gray-500" />
            <p className="text-sm font-semibold text-gray-500">
              Spreadsheets &amp; legacy tools
            </p>
            <p className="text-sm font-semibold text-indigo-600">
              Speech Agenda
            </p>
          </div>
          <div className="space-y-4">
            {rows.map((row) => (
              <div
                key={row.dimension}
                className="rounded-2xl bg-gray-50 p-6 shadow-sm ring-1 ring-gray-200 sm:grid sm:grid-cols-3 sm:gap-x-6">
                <p className="text-base font-semibold leading-7 text-gray-900">
                  {row.dimension}
                </p>
                <div className="mt-2 sm:mt-0">
                  <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 sm:hidden">
                    Spreadsheets &amp; legacy tools
                  </p>
                  <p className="text-base leading-7 text-gray-600">
                    {row.legacy}
                  </p>
                </div>
                <div className="mt-3 sm:mt-0">
                  <p className="text-xs font-semibold uppercase tracking-wide text-indigo-600 sm:hidden">
                    Speech Agenda
                  </p>
                  <p className="text-base font-medium leading-7 text-gray-900">
                    {row.speechAgenda}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
